import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy
} from '@angular/router';

/**
 * A person page is never reused for another person. Angular reuses a page
 * when only its route params change, and the person page's panels (photo,
 * reserved times, forms, recipients) load once per page: a reused page kept
 * showing the previous person. Routes opt in with data.newPagePerPerson;
 * every other route keeps Angular's default.
 */
@Injectable({ providedIn: 'root' })
export class PersonRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (!super.shouldReuseRoute(future, curr)) {
      return false;
    }
    if (future.routeConfig?.data?.['newPagePerPerson']) {
      return future.params['id'] === curr.params['id'];
    }
    return true;
  }
}
